var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"lm-card",style:({ height: _vm.height }),on:{"click":function($event){return _vm.$emit('click')}}},[_c('section',{staticClass:"lm-card_content"},[_c('img',{class:['is_block', {
      'is_scale': _vm.scale
    }],attrs:{"src":_vm.src}})]),_c('section',{staticClass:"lm-card_text"},[_c('section',{staticClass:"lm-card_intro"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }